module.exports = __webpack_public_path__ + "img/nautilus21.7258f382.png";